
import { useState } from "react";
import axiosClient from "../api/axiosClient";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress
} from "@mui/material";
import { Save, ArrowBack } from "@mui/icons-material";

export default function AddNote() {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [reference, setReference] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async () => {
    if (!title.trim() || !desc.trim()) {
      setError("Title and Description are required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await axiosClient.post("api/notes/add", {
        title,
        description: desc,
        reference_link: reference
      });
      navigate("/notes");
    } catch (err) {
      setError("Failed to save note. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          // background: "linear-gradient(135deg, #3E1E68 0%, #5D2F77 100%)",
          background:"#2a1c32ff",
          color: "white",
          borderRadius: 3
        }}
      >
        {/* Header */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
            sx={{
              color: "white",
              mr: 2,
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.1)"
              }
            }}
          />
          <Typography variant="h4" component="h1" fontWeight="bold">
            Add New Note
          </Typography>
        </Box>

        {/* Error Alert */}
        {error && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
            {error}
          </Alert>
        )}

        {/* Form */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="subtitle2" sx={{ color: "white",}}>
    Title
  </Typography>
          <TextField
            // label="Title"
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                borderRadius: 2,
                "&:hover fieldset": {
                  borderColor: "#ffffff"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ffffff"
                }
              },
              "& .MuiInputLabel-root": {
                color: "white"
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "white"
              }
            }}
          />
          <Typography variant="subtitle2" sx={{ color: "white",}}>
    Description
  </Typography>

          <TextField
            // label="Description"
            variant="outlined"
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            required
            multiline
            rows={6}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                borderRadius: 2,
                "&:hover fieldset": {
                  borderColor: "#ffffff"
                }
              }
              
            }}
          />
          

 <Typography variant="subtitle2" sx={{ color: "white",}}>
    Reference Link
  </Typography>

  <TextField
    variant="outlined"
    value={reference}
    onChange={(e) => setReference(e.target.value)}
    fullWidth
    sx={{
      "& .MuiOutlinedInput-root": {
        backgroundColor: "white",
        borderRadius: 2,
      }
    }}
  />


          {/* Action Buttons */}
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={() => navigate(-1)}
              sx={{
                color: "white",
                borderColor: "white",
                px: 4,
                "&:hover": {
                  borderColor: "white",
                  backgroundColor: "rgba(255,255,255,0.1)"
                }
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={submit}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <Save />}
              sx={{
                backgroundColor: "white",
                color: "#3E1E68",
                px: 4,
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                  transform: "translateY(-2px)",
                  boxShadow: 3
                },
                "&:disabled": {
                  backgroundColor: "rgba(255,255,255,0.5)"
                }
              }}
            >
              {loading ? "Saving..." : "Save Note"}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}
